import React from 'react';

import styles from './style.module.scss';

const StatusBox = ({ color, number, status, icon }) => (
  <div className={styles.box} style={{ backgroundColor: color }}>
    <div className={styles.boxContent}>
      <div className={styles.numberContainer}>
        <div className={styles.icon}>{icon}</div>
        <p className={styles.number}>{number}</p>
      </div>
      <span className={styles.status}>{status}</span>
    </div>
  </div>
);

export default StatusBox;
